import { render, staticRenderFns } from "./AddMessageForward.vue?vue&type=template&id=675b5762&"
import script from "./AddMessageForward.vue?vue&type=script&lang=js&"
export * from "./AddMessageForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675b5762')) {
      api.createRecord('675b5762', component.options)
    } else {
      api.reload('675b5762', component.options)
    }
    module.hot.accept("./AddMessageForward.vue?vue&type=template&id=675b5762&", function () {
      api.rerender('675b5762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/AddMessageForward.vue"
export default component.exports